import React, { useState } from "react";
import "./Navbar.scss";
import { FaBars, FaTimes } from "react-icons/fa";
import Navregister from "../../Common/NavDropdown/Navregister";
import NavDropdown from "../../Common/NavDropdown/NavDropdown";
import Images from "../../Data/images";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="navbar">
      <div className="nav-logo">
        <a href="/" className="logo">
          <img src={Images.logo} alt="logo" />
        </a>
        <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <FaTimes /> : <FaBars />}
        </div>
      </div>
      <div className="nav-line"></div>
      <div className={`nav-links ${menuOpen ? "active" : ""}`}>
        <div className="nav_maincontainer">
          <Link to="Service">Services</Link>
          <Link to="aboutus">About Us</Link>
          <Link to="technology">Technology</Link>
          <Link to="locations">Locations</Link>
          <Link to="career">Career</Link>
          <Link to="contact">Contact</Link>
          <Link to="emergencies">Emergencies</Link>
          <Link to="consulting">Consulting</Link>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
